import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { Reservation } from '../../models/reservation';
import { GenericPaginated } from '../../models/generic-paginated';
import { Observable } from 'rxjs';
import { Generic } from '../../models/generic';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getReservationsList = (params?: Params): Observable<GenericPaginated<Reservation>> => {
    return this.http.get<GenericPaginated<Reservation>>(`${this.baseUrl}/reservations`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getReservationById = (reservationId: string): Observable<Generic<Reservation>> => {
    return this.http.get<Generic<Reservation>>(`${this.baseUrl}/reservations/${reservationId}`);
  }

  cancelReservation = (reservationID: number): Observable<Reservation> => {
    return this.http.delete<Reservation>(`${this.baseUrl}/reservations/${reservationID}`)
  }
}
